module.exports = __webpack_public_path__ + "static/media/David Silverstone CV.a5bb4fa3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documents/David Silverstone CV.pdf
// module id = 335
// module chunks = 0